import { authConfig } from "./authConfig";

export const timeToExpireInSecond = () => {
  const oidcStorage = sessionStorage.getItem(
    `oidc.user:${authConfig.authority}:${authConfig.client_id}`
  );
  const expires_at = JSON.parse(oidcStorage!)?.expires_at;
  const currentTimeInSecond = Math.floor(Date.now() / 1000);
  return expires_at - currentTimeInSecond;
};

export const isNotNil = (value: string | null | undefined): value is string => {
  return value !== null && value !== undefined && value !== "";
};

export const isNotEmpty = <T extends ArrayLike<unknown>>(
  value: T | null | undefined
): value is T => {
  return value !== null && value !== undefined && value.length > 0;
};

export const jsonParse = (value: string | null | undefined) => {
  try {
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};

export interface IDecodedToken {
  auth_time: number;
}

export const addMinutesToAuthTime = (
  authTime: number,
  minutes: number
): number => {
  return authTime + minutes * 60;
};
